import React, {useState} from 'react'
import {Button, Card, CardBody, Center, FormControl, FormLabel, Heading, Image, Input, Stack, Text, VStack} from '@chakra-ui/react'
import {AuthAPI} from '../../../apis/AuthAPI'
import useAuthStore from '../../../stores/authStore'
import {useNavigate} from 'react-router-dom'

function LoginForm() {
    const navigate = useNavigate()
    const setAccessToken = useAuthStore((state) => state.setAccessToken)
    const setUser = useAuthStore((state) => state.setUser)

    const [formData, setFormData] = useState({
        login: '',
        password: '',
    })
    const handleChange = (event) => {
        const {name, value} = event.target
        setFormData({
            ...formData,
            [name]: value,
        })
    }
    const handleSubmit = async (event) => {
        event.preventDefault()
        AuthAPI
            .login(formData.login, formData.password)
            .then((resp) => {
                if (resp?.status === 0) {
                    setAccessToken(resp.token)
                    setUser(resp.user)
                    navigate('/countings')
                } else {
                    alert('Login failed: ' + resp?.message)
                }
            })
    }
    return (
        <Center minH='75vh' py={{base: 6, md: 10}} px={{base: 0, md: 4}}>
            <Card
                w='full'
                maxW='440px'
                borderWidth='1px'
                borderColor='gray.200'
                borderRadius='2xl'
                boxShadow='lg'
                overflow='hidden'
                borderTopWidth='4px'
                borderTopColor='green.500'
            >
                <CardBody p={{base: 6, md: 10}}>
                    <VStack spacing={3} mb={8} textAlign='center'>
                        <Image
                            src={`${process.env.PUBLIC_URL}/images/logo.png`}
                            alt='Yaad logo'
                            boxSize='72px'
                            objectFit='contain'
                            mb={2}
                        />
                        <Heading as='h1' size='lg' color='gray.800'>
                            Yaad Dashboard
                        </Heading>
                        <Text color='gray.600' fontSize='sm'>
                            Sign in to your account to continue
                        </Text>
                    </VStack>
                    <form onSubmit={handleSubmit}>
                        <Stack spacing={5}>
                            <FormControl isRequired>
                                <FormLabel htmlFor='login-username' fontSize='sm'>Username</FormLabel>
                                <Input
                                    id='login-username'
                                    name='login'
                                    value={formData.login}
                                    type='text'
                                    autoComplete='username'
                                    onChange={handleChange}
                                    size='lg'
                                    borderRadius='lg'
                                    focusBorderColor='green.500'
                                />
                            </FormControl>
                            <FormControl isRequired>
                                <FormLabel htmlFor='login-password' fontSize='sm'>Password</FormLabel>
                                <Input
                                    id='login-password'
                                    name='password'
                                    value={formData.password}
                                    type='password'
                                    autoComplete='current-password'
                                    onChange={handleChange}
                                    size='lg'
                                    borderRadius='lg'
                                    focusBorderColor='green.500'
                                />
                            </FormControl>
                            <Center pt={3}>
                                <Button type='submit' colorScheme='green' size='lg' minW='160px' borderRadius='lg'>
                                    Log in
                                </Button>
                            </Center>
                        </Stack>
                    </form>
                </CardBody>
            </Card>
        </Center>
    )
}

export default LoginForm